

export const getUsuarioStorage= ()=>{

    return {
        agente: localStorage.getItem('agente') || null,
        uidUsuario: localStorage.getItem('uidUsuario') || null,
        entidad: localStorage.getItem('entidad') || null,
        imagenLogo: localStorage.getItem('imagenLogo') || null,
        imagenIcono: localStorage.getItem('imagenIcono') || null,
        modulo: localStorage.getItem('modulo') || null,
        uidModulo: localStorage.getItem('uidModulo') || null,
        pantallas: localStorage.getItem('pantallas') || null,

    }
}